import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { pushIf } from "./utils/pushIf";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceListRetrievalNotificationState = createStateReducer(initialState, {
  [events.retrieveListFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "retrieveList",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceListRetrievalNotificationState };
